
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59 28h-2.18c-.951-5.666-5.85-10-11.748-10-5.822 0-10.696 4.119-11.825 9.579-.971-.814-2.079-1.246-3.247-1.246-1.167 0-2.274.432-3.245 1.245C25.639 22.118 20.825 18 15.072 18 8.756 18 3.565 22.851 3.051 29H1a1 1 0 1 0 0 2h2.051c.514 6.149 5.705 11 12.021 11 6.467 0 11.736-5.207 11.911-11.671.853-1.285 1.915-1.996 3.017-1.996 1.102 0 2.164.712 3.017 1.996C33.195 36.793 38.528 42 45.072 42 51.649 42 57 36.617 57 30h2a1 1 0 1 0 0-2zM15.072 40C9.519 40 5 35.514 5 30s4.519-10 10.072-10C20.64 20 25 24.393 25 30s-4.36 10-9.928 10zm30 0C39.519 40 35 35.514 35 30s4.519-10 10.072-10C50.64 20 55 24.393 55 30s-4.36 10-9.928 10z"}})])
          )
        }
      }
    